<template>
  <div class="dashboard profile">
    <div v-if="hasPaymentMethod && !isMobile" class="user-data">
      <div class="container-image">
        <p class="user-name">{{ userName }}</p>
      </div>
      <div class="text">
        <h3>{{ name }}</h3>
        <p>{{ userInfo.emailUser }}</p>
      </div>
      <span class="admin">{{ isAdmin ? $t('settings.administrator') : $t('settings.guest')}}</span>

      <div class="menu">
        <router-link :class="[($route.name === ROUTES.INFO) ? 'option-active' : 'option']" to="/profile/info" :aria-label="$t('sidebar.info')" :title="$t('sidebar.info')" tag="button">
          <div style="display: flex; align-items: center;">
            <info-icon size="1x" class="custom-class"></info-icon>
            <span>{{ $t('sidebar.info') }}</span>
          </div>
          <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </router-link>
        <router-link :class="[($route.name === ROUTES.SETTINGS) ? 'option-active' : 'option']" to="/profile/settings" :aria-label="$t('sidebar.settings')" :title="$t('sidebar.settings')" tag="button">
          <div style="display: flex; align-items: center;">
            <settings-icon size="1x" class="custom-class"></settings-icon>
            <span>{{ $t('sidebar.settings') }}</span>
          </div>
          <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </router-link>
        <router-link :class="[($route.name === ROUTES.ACCOUNT) ? 'option-active' : 'option']" to="/profile/account" :aria-label="$t('sidebar.accountAccess')" :title="$t('sidebar.accountAccess')" tag="button">
          <div style="display: flex; align-items: center;">
            <user-icon size="1x" class="custom-class"></user-icon>
            <span>{{ $t('sidebar.accountAccess') }}</span>
          </div>
          <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </router-link>
        <router-link v-if="!resellerPaymentMethod" :class="[($route.name === ROUTES.INVOICING || $route.name === 'Invoicing Plans') ? 'option-active' : 'option']" to="/profile/invoicing" :aria-label="$t('buttons.planBilling')" :title="$t('buttons.planBilling')" tag="button">
          <div style="display: flex; align-items: center;">
            <dollar-sign-icon size="1x" class="custom-class"></dollar-sign-icon>
            <span>{{ $t('buttons.planBilling') }}</span>
          </div>
          <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
        </router-link>
      </div>
    </div>
    <div v-else-if="isMobile && hasPaymentMethod" style="background: var(--light-blue); padding: 0 1em;">
      <div style="display: flex; align-items: center; justify-content: center;">
        <div class="container-image">
          <p class="user-name">{{ userName }}</p>
        </div>
        <div class="text">
          <h3>{{ name }}</h3>
          <p>{{ userInfo.emailUser }}</p>
          <span v-if="isAdmin" class="admin">{{ $t('settings.administrator') }}</span>
          <span v-else class="admin">{{ $t('settings.guest') }}</span>
        </div>
      </div>
      <ul id="nav">
        <li :class="{ active: $route.name === ROUTES.INFO }"><router-link :to="{name: ROUTES.INFO}">{{ $t('sidebar.info') }}</router-link></li>
        <li :class="{ active: $route.name === ROUTES.SETTINGS }"><router-link :to="{name: ROUTES.SETTINGS}">{{ $t('sidebar.settings') }}</router-link></li>
        <li :class="{ active: $route.name === ROUTES.ACCOUNT }"><router-link :to="{name: ROUTES.ACCOUNT}">{{ $t('settings.account') }}</router-link></li>
        <li v-if="!resellerPaymentMethod" :class="{ active: ($route.path === '/profile/invoicing' || $route.path === '/profile/invoicing/plans') }"><router-link to="/profile/invoicing">{{ $t('settings.plan') }}</router-link></li>
      </ul>
    </div> 
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { InfoIcon, ChevronRightIcon, SettingsIcon, UserIcon, DollarSignIcon } from 'vue-feather-icons';
import { ROUTES } from '../router';

export default {
  name: 'settings',
  components: {
    InfoIcon,
    ChevronRightIcon,
    SettingsIcon,
    UserIcon,
    DollarSignIcon
  },
  data() {
    return {
      ROUTES,
    };
  },
  computed: {
    ...mapState([ 'userInfo', 'accountInfo', 'user' ]),
    ...mapGetters(['hasPaymentMethod']),
    isMobile () {
      return window.innerWidth <= 768;
    },
    name() {
      return this.userInfo.firstname + ' ' + this.userInfo.lastname;
    },
    userName() {
      return this.userInfo.firstname.substr(0, 1) + this.userInfo.lastname.substr(0, 1);
    },
    isAdmin() {
      return this.accountInfo.email === this.userInfo.email;
    },
    resellerPaymentMethod () {
      return this.user.perm.paymentMethod === 2;
    }
  },
};
</script>
